import { ITokenStatus } from "./models";

export default class AuthState {
  status: string = "";
  csrfTokenEnabled: boolean = false;
  hasToken: boolean = false;
  isConfirmed: boolean = false;
  tokenStatus: ITokenStatus = { has_token: false };
  authError: string = "";
  tokenError: string = "";
  tokenLoaded: boolean = false;
}
